import type {SeriesIssueInfo} from './SeriesIssueInfo';
import type {SeriesPattern} from './SeriesPattern';
import type {SeriesTypeEnum} from './SeriesTypeEnum';

export type Series = {
  id: string;
  name: string;
  type: SeriesTypeEnum;
  patterns: Array<SeriesPattern>;
  firstIssueInfo: SeriesIssueInfo | null;
  lastIssueInfo: SeriesIssueInfo | null;
  unique: boolean;
  system: boolean;
};
